/**
 * containerGroups selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';
import { ContainerGroupState, ContainerGroup } from './types';

interface State {
    containerGroups: {
        [s: string]: {
            name: string;
        };
    };
}

interface Props {
    containerGroupId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectContainerGroups = (state: State): ContainerGroupState =>
    state.containerGroups;
const selectContainerGroupId = (state: State, props: Props): any =>
    props.containerGroupId && `${props.containerGroupId}`;

const selectContainerGroupsArray = createDeepEqualSelector(
    selectContainerGroups,
    (containerGroupsState) => Object.values(containerGroupsState)
);

const selectContainerGroup = createDeepEqualSelector(
    selectContainerGroups,
    selectContainerGroupId,
    (containerGroupsState, containerGroupId) =>
        containerGroupId && containerGroupsState[containerGroupId]
);

const makeSelectContainerGroupValue = <T extends keyof ContainerGroup>(
    field: T
): any =>
    createDeepEqualSelector(
        selectContainerGroup,
        (containerGroupState) =>
            containerGroupState && containerGroupState[field]
    );

export {
    selectContainerGroups,
    selectContainerGroupsArray,
    selectContainerGroup,
    makeSelectContainerGroupValue
};
